export class QuantityErrorConstants {
  public static ZERO_QUANTITY_ERROR = "Quantity must be in range 1 - 99999";
  public static ZERO_DISPLAY_QUANTITY_ERROR =
    "Display Quantity must be in range 1 - 99999";
  public static INVALID_DISPLAY_QUANTITY_ERROR =
    "Display Qty cannot be greater than Quantity";
}
